export function setupExternalLinks(): void {
    const links = document.querySelectorAll('a');

    links.forEach((link) => {
        const url = link.getAttribute('href');
        const target = link.getAttribute('target');
        const domain = window.location.hostname;
        let appendText = false;
        let newTab = false;

        if (
            url &&
            url.indexOf(domain) === -1 &&
            url.charAt(0) !== '/' &&
            url.charAt(0) !== '#' &&
            url.indexOf('mailto:') === -1 &&
            url.indexOf('tel:') === -1
        ) {
            appendText = true;
        }

        if (target && target === '_blank') {
            appendText = true;
            newTab = true;
        }

        if (appendText && newTab) {
            link.insertAdjacentHTML('beforeend', '<span class="sr-only"> this link will open a new tab.</span>');
        } else if (appendText && !newTab) {
            link.insertAdjacentHTML('beforeend', '<span class="sr-only"> this link leads offsite.</span>');
        }
    });
}
